import * as Sentry from '@sentry/react'
import { StreamingEvent } from '../models/StreamingAIAgent'
import { createParser, EventSourceMessage, EventSourceParser } from 'eventsource-parser'

export const createSSEParser = (onStreamingEvent: (event: StreamingEvent) => Promise<void>): EventSourceParser => {
  return createParser({
    onEvent: async (event: EventSourceMessage) => {
      if (!event.event) {
        return
      }
      try {
        await onStreamingEvent({
          event: event.event,
          data: event.data,
        })
      } catch (e) {
        Sentry.captureException(e)
      }
    },
  })
}

const ID_START_OFFSET = 6
const ID_END_OFFSET = 22

export const parseEventData = (eventData: string) => {
  if (!eventData) {
    return {}
  }
  try {
    return JSON.parse(eventData)
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setExtra('eventData', `${eventData.substring(0, 5)}...${eventData.substring(eventData.length - 15)}`)
      const idIndex = eventData.indexOf('id')
      if (idIndex >= 0) {
        scope.setExtra('id', eventData.substring(idIndex + ID_START_OFFSET, idIndex + ID_END_OFFSET))
      }
      Sentry.captureException(e)
    })
  }
  return {}
}
